import { useMemo } from 'react';

import { AppContext } from './app-context';
import { ComponentController } from '../core/controller';
import { DefaultInteractionProvider } from '@r-services/ui-interactions';
import { RenderLayerProvider } from '@r-services/render-layers';

type DesignerProviderProps = {
	controller: ComponentController;
	children: React.ReactElement | React.ReactElement[] | null;
};

export const AppRootContextProvider = ({ controller, children }: DesignerProviderProps): React.ReactElement => {
	const appContextValue = useMemo(() => ({ controller }), [controller]);

	return (
		<AppContext.Provider value={appContextValue}>
			{/* <ViewportProvider controller={controller}> */}
				<RenderLayerProvider renderLayerManager={controller.renderLayer}>
					<DefaultInteractionProvider>
						{children}
					</DefaultInteractionProvider>
				</RenderLayerProvider>
			{/* </ViewportProvider> */}
		</AppContext.Provider>
	);
};
